import { BadgeAccountsSelectionPanel } from '@juvare/badging/ui/features/badge-management/components/BadgeAccountsSelectionPanel';
import { BadgeCreateWizardStepContainer } from '@juvare/badging/ui/features/badge-management/components/BadgeCreateWIzard/BadgeCreateWizardStepContainer';
import { WizardStepComponentProps, WizardStepComponentRef } from '@juvare/common-form-ui/Wizard';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BadgeCreateWizardStep3Data, RmsAccountSelection } from './types';

export const RmsBadgeCreateWizardStep3 = React.forwardRef<WizardStepComponentRef, WizardStepComponentProps>((props, ref) => {
    const { t } = useTranslation('rms');
    const data = props.data ?? {};

    const [accounts, setAccounts] = React.useState<RmsAccountSelection[]>(data.accounts);

    React.useImperativeHandle(ref, () => ({
        getData: (): BadgeCreateWizardStep3Data => {
            return {
                accounts,
            };
        },
        submit: () => {
            const dataNew: BadgeCreateWizardStep3Data = {
                accounts,
            };
            return Promise.resolve(
                props.onSubmit(dataNew).then((response) => {
                    props.onSubmitSuccess(dataNew, response);
                }),
            );
        },
    }));

    if (!data.badgeTemplate || !data.formSettings) {
        return null;
    }

    return (
        <BadgeCreateWizardStepContainer
            headerText={t('badging.create.wizard.step3.contentTitle')}
            badgeTemplateSelected={data.badgeTemplate}
            formSettings={data.formSettings}
            fixedBadgePreviewPosition={true}
        >
            <BadgeAccountsSelectionPanel
                usageType='badge-create'
                selectedAccounts={accounts}
                setSelectedAccounts={setAccounts}
                selectedAccountsTableInfoText={t('badging.create.wizard.step3.accountSelection.accountCanBeAddedLater')}
            />
        </BadgeCreateWizardStepContainer>
    );
});
